/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import AsyncSelect from 'react-select/async';
import TabGroup2 from "components/Tabs/TabGroup2";
import axios from "axios";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import CardFooter from "components/Card/CardFooter.js";

import styles from "assets/jss/material-dashboard-react/views/iconsStyle.js";

const useStyles = makeStyles(styles);

export default function SelectTest() {
  const [tap, setTap] = useState(checkTap());
  const [oldTap, setOldTap] = useState("");
  const [l2Option, setL2Option] = useState([]);
  const [l3Option, setL3Option] = useState([]);
  const [l4Option, setL4Option] = useState([]);
  const [l5Option, setL5Option] = useState([]);
  const [option2, setOption2] = useState();
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const [option5, setOption5] = useState("");
  const [oldOption4, setOldOption4] = useState("");
  const [oldOption3, setOldOption3] = useState("");
  const [oldOption2, setOldOption2] = useState("");
  const [oldOption1, setOldOption1] = useState("");
  const [defaultValue, setDefaultValue] = useState();
  const [value, setValue] = useState();
  const classes = useStyles();

  const onTap = e => {
    setOldTap(tap);
    setTap(e);
  };

  function checkTap() {
    return '1'
  }
  
  const options = [
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", disabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" }
  ];

 
  const loadOptions = (searchKey) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        !defaultValue &&
        console.log(l2Option);
        if(l2Option.length == 0){
            axios.get(
              "/api/v1/group2/" + tap)
              .then(response => {
                setDefaultValue(response.data.data.find((o) => o.value === ""));
                const filtered = response.data.data.filter((o) => o.label.includes(searchKey));
                resolve(filtered);
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            setDefaultValue(l2Option.find((o) => o.value === ""));
            const filtered = l2Option.filter((o) => o.label.includes(searchKey));
            resolve(filtered);
          }
      }, 5000);
    });
  };

  
  useEffect(() => {
    datasend();
    
    // axios("/api/v1/group2/" + tap)
    // .then(
    //   result2 => {
    //     var res = result2.data;
    //     setL2Option(res.data);
    //     setOldOption1(tap);
    //     console.log(l2Option);
    //     console.log(oldOption1);
    //   }, 
    //   error => {
    //     console.log(error);
    //   }
    // );  
  }, []);

  const datasend = async () => {
    await axios.get(
      "/api/v1/group2/" + tap)
      .then(response => {
        setL2Option(response.data.data);
        console.log(l2Option);
      })
      .catch(err => {
        console.log(err);
      });
    
  };

  useEffect(() => {

  }, [l2Option]);

  useEffect(() => {
    loadOptions("");
  }, [tap]);

  useEffect(() => {
    setOption2(defaultValue);
  }, [defaultValue]);

  const onChange = (option) => setOption2(option);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card plain>
          <CardHeader plain color="primary">
            <h4 className={classes.cardTitleWhite}>Material Design Icons</h4>
            <p className={classes.cardCategoryWhite}>
              Handcrafted by our friends from{" "}
              <a
                href="https://design.google.com/icons/?ref=creativetime"
                target="_blank"
              >
                Google
              </a>
            </p>
          </CardHeader>
          <CardBody>
          <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TabGroup2 tap={onTap} setTap={tap} />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                <AsyncSelect 
                  loadOptions={loadOptions} 
                  defaultOptions   
                  value={option2}
                  onChange={onChange} />
                </GridItem>
              </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Icon>
                  <AssignmentInd />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>กรุณาเลือก</p>
              <h3 className={classes.cardTitle}>
                ตัวชี้วัด <small></small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TabGroup2 tap={onTap} setTap={tap} />
                </GridItem>
              </GridContainer>
              <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <AsyncSelect 
                  loadOptions={loadOptions} 
                  defaultOptions   
                  value={option2}
                  onChange={onChange} />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
            </CardBody>
            <CardFooter chart>
              {/* <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div> */}
            </CardFooter>
          </Card>
        </GridItem>
    </GridContainer>
  );
}
